import { put, select, takeLatest, all } from 'redux-saga/effects';
import { notify } from '@mrlannigan/reapop';
import { sagaError } from 'helpers/handleGenericSagaError';
import apiAuthCall from 'helpers/apiAuthCall';

import { actions, hyperLocalFetched, hyperLocalCampaignsFetched, hyperLocalZipDataFetched } from './duck';
import { hyperLocalEndpoint, hyperLocalZipDatEndpoint } from './selectors';

function* apiCall(action, api, path) {
    return yield apiAuthCall(
        action.getState(),
        [api, api.request],
        {
            method: 'post',
            url: yield select(hyperLocalEndpoint, { path }),
            data: { path }
        }
    );
}

export function* fetchHyperLocalCampaigns(api, action) {
    try {
        const results = yield apiCall(action, api, action.payload.path);

        yield put(hyperLocalCampaignsFetched({ results: results.data }));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchHyperLocal(api, action) {
    try {
        const results = yield all(action.payload.map(datasource => apiCall(action, api, datasource.path)));

        const groupedResults = results.reduce((acc, elem, idx) => {
            acc[action.payload[idx].key] = elem.data;
            return acc;
        }, {});

        yield put(hyperLocalFetched({ hasData: true, results: groupedResults }));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}

export function* fetchHyperLocalData(api, action) {
    try {
        const result = yield apiAuthCall(
            action.getState(),
            [api, api.request],
            {
                method: 'get',
                url: yield select(hyperLocalZipDatEndpoint, action.payload)
            }
        );

        yield put(hyperLocalZipDataFetched(result.data));
    } catch (err) {
        yield put(notify({
            id: action.payload.transactionId,
            ...sagaError(err)
        }));
    }
}


export default function* hyperLocalSagas({ api }) {
    yield all([
        takeLatest(actions.FETCH, fetchHyperLocal, api),
        takeLatest(actions.FETCH_CAMPAIGNS, fetchHyperLocalCampaigns, api),
        takeLatest(actions.FETCH_ZIP_DATA, fetchHyperLocalData, api)
    ]);
}



// WEBPACK FOOTER //
// ./src/services/hyperlocal/saga.js